(function () {
    'use strict';

    function booleanSearchFieldConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'common/directives/templates/booleanSearchFieldConfiguration.html',
            link: function (scope) {
            }
        };
    }

    booleanSearchFieldConfiguration.$inject = [];

    angular.module('ecap.common').directive('booleanSearchFieldConfiguration', booleanSearchFieldConfiguration);
})();

